import script from "./ResourcesView.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourcesView.vue?vue&type=script&setup=true&lang=js"

import "./ResourcesView.vue?vue&type=style&index=0&id=dda2ed4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dda2ed4a"]])

export default __exports__